import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Act, DoctorAct } from 'src/app/entities/act.entity/act';
import { ActeConsultationItem } from 'src/app/entities/consultation.entity';
import { DoctorActFormComponent } from '../../acts-form.module/doctor-act-form.component/doctor-act-form.component';
import { DoctorActsService } from 'src/app/services/doctor-acts.service/doctor-acts.service';
import { ActesFilter } from '../../acts-form.module/act-select-drawer/act-select-drawer.component';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';

export class ConsultationItemValidation {
  controlsValidation: Record<symbol, symbol | null> = {}
  get isValid(): boolean {
    return Array.from(Object.values(this.controlsValidation)).every(elm => elm === null)
  }
}

export class ActeConsultationnItemValidation extends ConsultationItemValidation {
  controlsValidation: { act: 'required' | null, note: null, montant: 'required' | 'number' | null, duration: 'required' | 'number' | 'min' | null } = {
    act: null,
    note: null,
    montant: null,
    duration: null
  };

  constructor(controlsValidation: { act: 'required' | null, note: null, montant: 'required' | 'number' | null, duration: 'required' | 'number' | 'min' | null }) {
    super()
    this.controlsValidation = controlsValidation
  }
}

@Component({
  selector: 'app-consultation-act-form-list',
  templateUrl: './consultation-act-form-list.component.html',
  styleUrls: ['./consultation-act-form-list.component.css']
})
export class ConsultationActFormListComponent implements OnInit ,OnChanges {
  @Input() actesConsultationItems: Array<ActeConsultationItem> = new Array();
  @Output() actesConsultationItemsChange: EventEmitter<Array<ActeConsultationItem>> = new EventEmitter();
  actes: Array<DoctorAct> = new Array();
  actesfilter: Array<ActesFilter> = new Array({ acteConsultation: new ActeConsultationItem({}), selected: false ,index:0});
  drawerActive: boolean = false;
  actesFilter:string=""
  _submitted: boolean = false;

  actesNotes: { [key: string]: string } = {};
  actesClinique: { [key: string]: Number } = {};
  actesTotal: { [key: string]: Number } = {};
  actesDoctor: { [key: string]: Number } = {};
  expandedGroups: { [key: string]: boolean } = {};

  @Input() set submitted(v: boolean) {
    this._submitted = v;
    if (this._submitted) {
      this.actesConsultationItems = this.actesConsultationItems.filter(e => e.act && e.act.id_Acte != undefined && e.act.id_Acte.length > 0)
      this._change()
    }
  }
  get submitted(): boolean {
    return this._submitted;
  }

  @Output() validation: EventEmitter<boolean> = new EventEmitter()
  @ViewChild('actForm', { read: DoctorActFormComponent, static: true }) actForm!: DoctorActFormComponent;

  constructor(
    private doctorActsService: DoctorActsService, 
    private toasterService: ToastrService,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['actesConsultationItems']) {
      this.syncNotesFromConsultationItems();
      this.syncCliniqueFromConsultationItems();
      this.syncTotalFromConsultationItems();
      this.syncDoctorFromConsultationItems();
      this.cdRef.detectChanges();
    }
  }
 get doctor(): Doctor {
    return new Doctor(this.authService.getCurrentUser()!);
  }
  get isValid(): boolean {
    return this.actesConsultationItems.every(item => this.validateConsultationItem(item).isValid)
  }

  private _groupedActesByFamily: Array<{familyName: string, actes: DoctorAct[]}> = [];
  private _actesCache: DoctorAct[] = [];

  get groupedActesByFamily(): Array<{familyName: string, actes: DoctorAct[]}> {
    if (this._hasActesChanged() || this._groupedActesByFamily.length === 0) {
      this._updateGroupedActes();
    }
    return this._groupedActesByFamily;
  }

toggleGroup(familyName: string) {
  this.expandedGroups[familyName] = !this.expandedGroups[familyName];
}

isGroupExpanded(familyName: string): boolean {
  return this.expandedGroups[familyName] ?? true; // ouvert par défaut
}

  private _hasActesChanged(): boolean {
    return this.actes.length !== this._actesCache.length || 
           this.actes.some((act, index) => act !== this._actesCache[index]);
  }

  private _updateGroupedActes(): void {
    const familiesMap = new Map<string, DoctorAct[]>();
    
    this.actes.forEach(act => {
      const familyName = act.actes?.famille_Acte || 'Autres';
      if (!familiesMap.has(familyName)) {
        familiesMap.set(familyName, []);
      }
      familiesMap.get(familyName)!.push(act);
    });

    this._groupedActesByFamily = Array.from(familiesMap.entries())
      .map(([familyName, actes]) => ({ familyName, actes }))
      .sort((a, b) => a.actes[0].listOrder - b.actes[0].listOrder);
    
    this._actesCache = [...this.actes];
  }

isAllActesInFamilySelected(familyName: string): boolean {
  const familyGroup = this.groupedActesByFamily.find(group => group.familyName === familyName);
  
  if (!familyGroup || familyGroup.actes.length === 0) {
    return false;
  }
  
  const selectedCount = familyGroup.actes.filter(act => this.isActeSelected(act)).length;
  
  // Retourne true seulement si TOUS les actes sont sélectionnés
  return selectedCount === familyGroup.actes.length;
}

  toggleAllActesInFamily(familyName: string, event: any): void {
    const familyGroup = this.groupedActesByFamily.find(group => group.familyName === familyName);
    
    if (!familyGroup) return;
    
    const isChecked = event.target.checked;
    
    familyGroup.actes.forEach(act => {
      if (isChecked && !this.isActeSelected(act)) {
        this.addActeToConsultation(act);
      } else if (!isChecked && this.isActeSelected(act)) {
        this.removeActeFromConsultation(act);
      }
    });
  }

  private syncNotesFromConsultationItems(): void {
    this.actesConsultationItems.forEach(item => {
      if (item.act?.id_Acte) {
        this.actesNotes[item.act.id_Acte] = item.note || '';
      }
    });
  }
 private syncCliniqueFromConsultationItems(): void {
    this.actesConsultationItems.forEach(item => {
      if (item.act?.id_Acte) {
        this.actesClinique[item.act.id_Acte] = (item.montant_clinic_consultation_acte) || 0;
      }
    });
  }
   private syncTotalFromConsultationItems(): void {
    this.actesConsultationItems.forEach(item => {
      if (item.act?.id_Acte) {
        this.actesTotal[item.act.id_Acte] = item.prix_total_consultation_acte || 0;
      }
    });
  }
   private syncDoctorFromConsultationItems(): void {
    this.actesConsultationItems.forEach(item => {
      if (item.act?.id_Acte) {
        this.actesDoctor[item.act.id_Acte] = item.montant_doctor_consultation_acte || 0;
      }
    });
  }
  private initializeActesNotes(): void {
    this.actes.forEach(act => {
      if (act.actes?.id_Acte) {
        if (this.actesNotes[act.actes.id_Acte] === undefined) {
          this.actesNotes[act.actes.id_Acte] = '';
        }
      }
    });
  }
   private initializeActesTotal(): void {
    this.actes.forEach(act => {
      if (act.actes?.id_Acte) {
        if (this.actesTotal[act.actes.id_Acte] === undefined) {
          this.actesTotal[act.actes.id_Acte] = act.montant || 0;
        }
      }
    });
  }
   private initializeClinique(): void {
    this.actes.forEach(act => {
      if (act.actes?.id_Acte) {
        if (this.actesClinique[act.actes.id_Acte] === undefined) {
          this.actesClinique[act.actes.id_Acte] = act.clinicPrice || 0;
        }
      }
    });
  }
   private initializeDoctor(): void {
    this.actes.forEach(act => {
      if (act.actes?.id_Acte) {
        if (this.actesDoctor[act.actes.id_Acte] === undefined) {
          this.actesDoctor[act.actes.id_Acte] = act.doctorPrice || 0;
        }
      }
    });
  }

  getActeNote(act: DoctorAct): string {
    if (!act.actes?.id_Acte) return '';
    return this.actesNotes[act.actes.id_Acte] || '';
  }

  onNoteBlur(act: DoctorAct): void {
    if (this.isActeSelected(act)) {
      this.updateSelectedActe(act);
    }
  }

  updateMontant(act: DoctorAct, event: Event): void {
    act.montant = Number((event.target as HTMLInputElement).value) || 0;
    if (this.isActeSelected(act)) {
      this.updateSelectedActe(act);
    }
  }

updateDoctorPrice(act: DoctorAct, event: Event): void {
    act.doctorPrice = Number((event.target as HTMLInputElement).value) || 0;
    this.actesTotal[act.actes.id_Acte] = Number(act.doctorPrice) + Number(this.actesClinique[act.actes.id_Acte]);
    act.clinicPrice=Number(this.actesClinique[act.actes.id_Acte]);
act.montant=Number(this.actesTotal[act.actes.id_Acte]);
    if (this.isActeSelected(act)) {
      this.updateSelectedActe(act);
    }
}

updateClinicPrice(act: DoctorAct, event: Event): void {
  
    act.clinicPrice = Number((event.target as HTMLInputElement).value) || 0;
    this.actesTotal[act.actes.id_Acte] = Number(this.actesDoctor[act.actes.id_Acte])+ Number(act.clinicPrice);
    act.doctorPrice=Number(this.actesDoctor[act.actes.id_Acte]);
    act.montant=Number(this.actesTotal[act.actes.id_Acte]);
    if (this.isActeSelected(act)) {
      this.updateSelectedActe(act);
    }
}


  updateNote(act: DoctorAct, event: Event): void {
    if (!act.actes?.id_Acte) return;
    
    const note = (event.target as HTMLTextAreaElement).value;
    this.actesNotes[act.actes.id_Acte] = note;
    
    if (this.isActeSelected(act)) {
      this.updateSelectedActe(act);
    }
  }

  ngOnInit(): void {
    this.doctorActsService.all().subscribe(res => {
      this.actes = Array.from(res || [], elm => new DoctorAct(DoctorAct.fromResponse(elm)));
      
      this.actes.forEach(act => {
        act.montant = act.montant || 0;
        act.doctorPrice = act.doctorPrice || 0;
        act.clinicPrice = act.clinicPrice || 0;
      });

      this.syncNotesFromConsultationItems();
      
      this.syncCliniqueFromConsultationItems();
      
      this.syncTotalFromConsultationItems();
      this.syncDoctorFromConsultationItems();
      this.initializeActesNotes();
      this.initializeActesTotal();
      this.initializeClinique();
      this.initializeDoctor();
      this.cdRef.detectChanges();
      
    }, error => this.toasterService.error('Problème de Chargements des Actes'));
  }

  validateConsultationItem(acteConsultationItem: ActeConsultationItem): ActeConsultationnItemValidation {
    return acteConsultationItem.act && acteConsultationItem.act.id_Acte != undefined && acteConsultationItem.act.id_Acte.length > 0 ? new ActeConsultationnItemValidation({
      act: null,
      note: null,
      montant: null,
      duration: acteConsultationItem.date_consultation_acte ? (!isNaN(Number(acteConsultationItem.date_consultation_acte)) ? (Number(acteConsultationItem.date_consultation_acte) < 1 ? 'min' : null) : 'number') : 'required'
    }) : new ActeConsultationnItemValidation({ act: null, note: null, montant: null, duration: null });
  }

  toggleActeForConsultation(act: DoctorAct, event: any): void {
    if (event.target.checked) {
      this.addActeToConsultation(act);
    } else {
      this.removeActeFromConsultation(act);
    }
  }

  isActeSelected(act: DoctorAct): boolean {
    if (!act.actes) return false;
    return this.actesConsultationItems.some(item => 
      item.act?.id_Acte === act.actes.id_Acte
    );
  }

  addActeToConsultation(act: DoctorAct): void {
    if (!act.actes) return;
    
    if (!this.isActeSelected(act)) {
      const newActeConsultation = new ActeConsultationItem({
        act: act.actes,
        date_consultation_acte: new Date(),
        prix_total_consultation_acte: Number(act.montant) || 0,
        montant_doctor_consultation_acte: Number(act.doctorPrice) || 0,
        montant_clinic_consultation_acte: Number(act.clinicPrice) || 0,
        note: this.getActeNote(act) // Utiliser la note actuelle
      });
      
      this.actesConsultationItems.push(newActeConsultation);
      this._change();
      this.cdRef.detectChanges();
    }
  }

  removeActeFromConsultation(act: DoctorAct): void {
    if (!act.actes) return;
    
    const index = this.actesConsultationItems.findIndex(item => 
      item.act?.id_Acte === act.actes.id_Acte
    );
    
    if (index !== -1) {
      this.actesConsultationItems.splice(index, 1);
      this._change();
      this.cdRef.detectChanges();
    }
  }

  updateSelectedActe(act: DoctorAct): void {
    if (!act.actes) return;
    
    const index = this.actesConsultationItems.findIndex(item => 
      item.act?.id_Acte === act.actes.id_Acte
    );
    
    if (index !== -1) {
      this.actesConsultationItems[index].prix_total_consultation_acte = Number(act.montant) || 0;
      this.actesConsultationItems[index].montant_doctor_consultation_acte = Number(act.doctorPrice) || 0;
      this.actesConsultationItems[index].montant_clinic_consultation_acte = Number(act.clinicPrice) || 0;
            this.actesConsultationItems[index].note = this.getActeNote(act);
      
      this._change();
    }
  }

  getFormattedDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  _change(): void {
    this.actesConsultationItemsChange.emit(this.actesConsultationItems);
    this.validation.emit(this.isValid);
  }

  @Input() set actesConsultationItemsInput(items: Array<ActeConsultationItem>) {
    if (items) {
      this.actesConsultationItems = items;
      this.syncNotesFromConsultationItems();
      this.syncCliniqueFromConsultationItems();
      this.syncTotalFromConsultationItems();
      this.syncDoctorFromConsultationItems();
      this.initializeActesNotes();
      this.cdRef.detectChanges();
    }
  }
}